import type { ICalendarDay, ICalendarHoliday } from "../store/apis/attendance.api";
import { WEEK_OFF_LABEL, WEEKDAYS } from "../constants/attendance";
export { WEEKDAYS };
import { isWeekOffDay, type WeekOffConfig } from "./weekOff";
import dayjs from "dayjs";

export function parseTime(iso: string | undefined): string {
  if (!iso) return "";
  const m = dayjs(iso);
  return m.isValid() ? m.format("HH:mm") : "";
}

export function formatStatValue(value: number | string, suffix?: string): string {
  const str = typeof value === "number" ? String(value) : value;
  return suffix ? `${str}${suffix}` : str;
}
export interface ResolvedDayMeta {
  status: string;
  isHoliday: boolean;
  holidayText: string | null;
  isFestival: boolean;
  isWeekOff: boolean;
}
export function resolveDayMeta(
  dayData: ICalendarDay | undefined,
  holidayRecord: ICalendarHoliday | undefined,
  weekOffConfig: WeekOffConfig | undefined,
  year: number,
  month: number,
  day: number
): ResolvedDayMeta {
  const dayStatus = dayData?.status || "";
  const dayIsHoliday = Boolean(dayData?.isHoliday);
  const dayHolidayName =
    dayIsHoliday && dayData?.holidayName?.trim()
      ? dayData.holidayName.trim()
      : null;

  const isWeekOff = isWeekOffDay(year, month, day, weekOffConfig);
  const orgHolidayName = holidayRecord?.name.trim() || null;
  const orgHolidayDesc = holidayRecord?.description?.trim() || null;
  const isMandatoryOrgHoliday = Boolean(holidayRecord?.isMandatory);

  let holidayText = null;
  let isFestival = false;

  if (isMandatoryOrgHoliday) {
    isFestival = true;
    if (isWeekOff) {
      holidayText = orgHolidayDesc ? `${orgHolidayName} - ${orgHolidayDesc}` : orgHolidayName;
    } else {
      holidayText = orgHolidayName;
    }
  } else if (isWeekOff) {
    isFestival = false;
    holidayText = WEEK_OFF_LABEL;
  } else {
    isFestival = false;
    holidayText = orgHolidayName || dayHolidayName || null;
  }

  const isHoliday = Boolean(holidayRecord) || dayIsHoliday || isWeekOff;
  const status = holidayRecord && !dayStatus ? "HL" : dayStatus;

  return { status, isHoliday, holidayText, isFestival, isWeekOff };
}